import React, { useRef, createRef, useState, useMemo } from 'react';
import FundWallet from '../../../Widgets/FundWallet';
import { images } from '../../Images';
import Button from '../../../../components/UI/Button/index';
import { useCreditClient } from '../../../../services/credit';

export const WIDGET_NAME = 'set_initial_funding_amount';

export default function FundWalletInCredit({
  app,
  toggles,
  answer,
  analytics
}) {
  const creditApplicationClient = useMemo(() => useCreditClient(), []);
  const [initialLoadAmount, setInitialLoadAmount] = useState();
  const ref = useRef(createRef());

  const handleErrors = async () => {
    if (ref.current) {
      const { errorChecking } = ref.current as any;
      if (typeof errorChecking === 'function') {
        return errorChecking();
      }
      return false;
    }
    return false;
  };

  const submitLoadAmountAndCredit = async () => {
    const creditDecision = creditApplicationClient.getCreditDecision();
    try {
      await handleErrors();
      answer({
        accessToken: app.registrationToken,
        questions: ['set_initial_funding_amount', 'credit_application'],
        answers: [
          initialLoadAmount,
          { credit_accepted: false, credit_decision: creditDecision }
        ]
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      <div>
        <h1 data-testid="fund-wallet-credit-header">
          Let’s set up your Parent’s Wallet
        </h1>
        <h2>
          Your Parent’s Wallet works like a real wallet. Load it with funds and
          transfer money to your child whenever, wherever, and for whatever.
        </h2>
        <h3>
          {toggles.walletMinimum?.displayAmount === 0.0
            ? 'Choose an initial amount to load.'
            : `Choose an initial amount of $${
                toggles.walletMinimum?.displayAmount ||
                toggles.walletMinimum?.amount
              } or more to load.`}
        </h3>
        <FundWallet
          app={app}
          ref={ref as any}
          widget="set_initial_funding_amount"
          changeAnswerValue={(_widgetName, initialLoadAmount) =>
            setInitialLoadAmount(initialLoadAmount)
          }
          shouldEnable={() => {}}
          toggles={toggles}
          analytics={analytics}
        />
        <Button
          text="Next"
          disabled={!initialLoadAmount}
          loading={app.loading}
          onClick={submitLoadAmountAndCredit}
        />
        {images.saritaTestimonial}
      </div>
    </>
  );
}
